<template>
  <validation-observer
    ref="formModalObserver"
    novalidate
    tag="form"
    @submit.prevent="handleModalSubmit"
  >
    <div class=" ">
      <div class="p-2">
        <div class="bg-white border-radius--light py-2">
          <div class="col-12 mb-2 pl-4 pt-3">
            <em class="fas fa-times-square text-orange mr-1" />
            <span class="ml-2">Estudiante para Admisión a Intervención</span>
          </div>

          <div class="row p-4">
            <div class="col-sm-6">
              <validation-provider
                v-slot="{ errors }"
                mode="eager"
                rules="required"
              >
                <custom-drop-down
                  id="forAdmission"
                  v-model="model.assignmentSpecialist"
                  custom-error-msg="Favor seleccionar especialista para Admisión"
                  :disabled="
                    admissionSpecialistDisabled ||
                      disabledForm ||
                      isAssignedStatus
                  "
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  label="Especialista para Admisión:"
                  :options="admissionInfo.assignmentSpecialists"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </div>

            <div class="col-sm-6">
              <validation-provider
                v-slot="{ errors }"
                mode="eager"
                :rules="
                  isAssignedStatus && hasPilotPermission ? '' : 'required'
                "
              >
                <custom-drop-down
                  id="forAdmissionService"
                  v-model="model.serviceSpecialist"
                  custom-error-msg="Favor seleccionar especialista de Servicio"
                  :disabled="
                    disabledForm || (isAssignedStatus && hasPilotPermission)
                  "
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  label="Especialista de Servicio:"
                  :options="admissionInfo.serviceSpecialists"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </div>
          </div>

          <div v-if="showDelayReason" class="row p-4">
            <div class="col-sm-6">
              <validation-provider
                v-slot="{ errors }"
                mode="eager"
                rules="required"
              >
                <custom-drop-down
                  v-model="model.delayReason"
                  custom-error-msg="Favor seleccionar la Razón de admisión tardia"
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  label="Razón de admisión tardia:"
                  :options="delay.reasons"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </div>

            <div v-show="showExtraDelayReason" class="col-sm-6">
              <validation-provider
                v-slot="{ errors }"
                mode="eager"
                :rules="showExtraDelayReason ? 'required' : ''"
              >
                <custom-drop-down
                  v-model="model.delayReasonExtra"
                  custom-error-msg="Favor seleccionar la Razón de rechazo de servicio"
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  label="Razón de rechazo de servicio:"
                  :options="delay.reasonsExtra"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </div>
          </div>

          <div v-if="showDelayReason" class="row p-4">
            <div class="col-12 mb-3 mb-md-0">
              <validation-observer ref="proposalContractDocuments">
                <validation-provider
                  v-slot="{ errors }"
                  name="Archivo"
                  rules="required"
                >
                  <custom-text-area
                    v-model="model.delayReasonDescription"
                    custom-error-msg="Favor escriba un comentario."
                    :error="errors[0]"
                    label="Comentario:"
                    :maxlength="3000"
                    :rows="2"
                    :show-char-count="true"
                  />
                </validation-provider>
              </validation-observer>
            </div>
          </div>

          <div class="p-2 ml-4 mr-4">
            <div class="row bg-light-gray p-4">
              <div class="col-sm-2">
                <validation-provider
                  v-slot="{ errors }"
                  mode="eager"
                  rules="required"
                >
                  <custom-date-picker
                    v-model="newAdmissionDate"
                    class="custom-datetime-picker-container"
                    custom-error-msg="Favor seleccionar fecha de admisión"
                    :disabled="disabledAdmissionDate"
                    :error="errors[0]"
                    label="Fecha Admisión:"
                    :max-date="admissionInfo.admission.effectiveDateFrom"
                  />
                </validation-provider>
              </div>

              <div class="col-sm-2">
                <validation-provider
                  v-slot="{ errors }"
                  mode="eager"
                  rules="required"
                >
                  <custom-date-picker
                    v-model="admissionInfo.admission.effectiveDateFrom"
                    class="custom-datetime-picker-container"
                    custom-error-msg="Favor seleccionar fecha de comienzo"
                    :disabled="startDateDisabled || disabledForm"
                    :error="errors[0]"
                    label="Fecha Comienzo:"
                    :max-date="admissionInfo.maxDate"
                    :min-date="admissionInfo.minDate"
                  />
                </validation-provider>
              </div>
              <div class="col-sm-2 border-right mr-5" />
              <div class="col-sm-2">
                <validation-provider
                  v-slot="{ errors }"
                  mode="eager"
                  :rules="disabledAdmissionDate ? '' : 'required'"
                >
                  <custom-time-picker
                    v-model="admission.admissionTimeStart"
                    class="custom-datetime-picker-container"
                    custom-error-msg="Favor seleccionar hora"
                    :disabled="disabledAdmissionDate || disabledForm"
                    :error="errors[0]"
                    label="Hora Desde:"
                    :max-date="new Date()"
                  />
                </validation-provider>
              </div>

              <div class="col-sm-2">
                <validation-provider
                  v-slot="{ errors }"
                  mode="eager"
                  :rules="disabledAdmissionDate ? '' : 'required'"
                >
                  <custom-time-picker
                    v-model="admission.admissionTimeEnd"
                    class="custom-datetime-picker-container"
                    custom-error-msg="Favor seleccionar hora"
                    :disabled="disabledAdmissionDate || disabledForm"
                    :error="errors[0]"
                    label="Hora Hasta:"
                    :max-date="new Date()"
                  />
                </validation-provider>
              </div>
            </div>
          </div>

          <div v-if="showServicePlaceSection" class="row p-4">
            <div class="col-12 mb-3">
              <em class="fas fa-info-circle text-orange mr-1" />
              <span>Lugar de Servicio donde ocurrió la Admisión</span>
            </div>

            <div class="col-12 row">
              <div class="col-sm-6 mb-4">
                <validation-provider
                  v-slot="{ errors }"
                  mode="eager"
                  :rules="temp_isServicePlaceSectionRequired"
                >
                  <custom-drop-down
                    id="forAdmission1"
                    v-model="model.locationType"
                    custom-error-msg="Favor seleccionar el tipo de lugar"
                    :disabled="disabledForm || isAdmissionDateReadOnly"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Tipo de Lugar:"
                    :options="admissionInfo.locationTypes"
                    placeholder="Seleccione"
                  />
                </validation-provider>
              </div>
              <div v-if="isSchool" class="col-sm-6 mb-4">
                <validation-provider
                  v-slot="{ errors }"
                  mode="eager"
                  :rules="temp_isServicePlaceSectionRequired"
                >
                  <custom-drop-down
                    id="forAdmission2"
                    v-model="model.district"
                    custom-error-msg="Favor seleccionar Distrito"
                    :disabled="disabledForm || isAdmissionDateReadOnly"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Distrito:"
                    :options="collections.districts"
                    placeholder="Seleccione"
                  />
                </validation-provider>
              </div>
              <div v-if="isOficinaProveedor" class="col-sm-6 mb-4">
                <validation-provider
                  v-slot="{ errors }"
                  mode="eager"
                  :rules="temp_isServicePlaceSectionRequired"
                >
                  <custom-drop-down
                    id="forAdmission2"
                    v-model="model.location"
                    custom-error-msg="Favor seleccionar Lugar de Servicio"
                    :disabled="disabledForm || isAdmissionDateReadOnly"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Lugar de Servicio:"
                    :options="collections.locations"
                    placeholder="Seleccione"
                  />
                </validation-provider>
              </div>
              <div
                v-if="isOficinaProveedor || isCsee || isHome"
                class="col-sm-6 mb-4"
              >
                <validation-provider
                  v-slot="{ errors }"
                  mode="eager"
                  :rules="temp_isServicePlaceSectionRequired"
                >
                  <custom-drop-down
                    id="forAdmission2"
                    v-model="model.municipality"
                    custom-error-msg="Favor seleccionar Municipio"
                    :disabled="disabledForm || isAdmissionDateReadOnly"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Municipio:"
                    :options="collections.municipalities"
                    placeholder="Seleccione"
                  />
                </validation-provider>
              </div>
              <div v-if="isCsee" class="col-sm-6 mb-4">
                <validation-provider
                  v-slot="{ errors }"
                  mode="eager"
                  :rules="temp_isServicePlaceSectionRequired"
                >
                  <custom-drop-down
                    id="forAdmission2"
                    v-model="model.center"
                    custom-error-msg="Favor seleccionar Centro"
                    :disabled="disabledForm || isAdmissionDateReadOnly"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Centro:"
                    :options="collections.centers"
                    placeholder="Seleccione"
                  />
                </validation-provider>
              </div>
              <div v-if="isSchool" class="col-sm-6">
                <validation-provider
                  v-slot="{ errors }"
                  mode="eager"
                  :rules="temp_isServicePlaceSectionRequired"
                >
                  <custom-drop-down
                    id="forAdmission3"
                    v-model="model.region"
                    custom-error-msg="Favor seleccionar Región"
                    :disabled="disabledForm || isAdmissionDateReadOnly"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Región:"
                    :options="collections.regions"
                    placeholder="Seleccione"
                  />
                </validation-provider>
              </div>
              <div v-if="isSchool" class="col-sm-6">
                <validation-provider
                  v-slot="{ errors }"
                  mode="eager"
                  :rules="temp_isServicePlaceSectionRequired"
                >
                  <custom-drop-down
                    id="forAdmission4"
                    v-model="model.school"
                    custom-error-msg="Favor seleccionar Escuela"
                    :disabled="disabledForm || isAdmissionDateReadOnly"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Escuela:"
                    :options="collections.schools"
                    placeholder="Seleccione"
                  />
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="row pr-4 pb-4">
            <div class="col-sm">
              <div class="d-flex justify-content-end mt-4">
                <action-button
                  i="fas fa-times-circle"
                  text="Cancelar"
                  variant="danger mr-2"
                  @click="dispose"
                />
                <action-button
                  :disabled="!canUpdate"
                  :i="isAssignedStatus ? 'fas fa-check' : ''"
                  :text="finishBtnText"
                  variant="success pl-4 pr-4"
                  @click="finish"
                />
                <action-button
                  v-if="hasAdmissionDate && !isEducationalDepartament"
                  :disabled="!canUpdate"
                  :i="isAssignedStatus ? 'fas fa-check' : ''"
                  text="Coordinar Servicios"
                  variant="success pl-4 pr-4 ml-2"
                  @click="finish(true)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomDropDown from '@/components/common/form/CustomDropDown';
import CustomDatePicker from '@/components/common/form/CustomDatePicker';
import CustomTimePicker from '@/components/common/CustomTimePicker';
import alert from '@/mixins/alert.mixin';
import AdmissionStatus from '@/utils/shared/constants/admissionStatus';
import ReferralTypes from '@/utils/shared/constants/referralTypes';
import ConfRelatedAcademicWeekFlagTypes from '@/utils/shared/constants/confRelatedAcademicWeekFlagTypes';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import moment from 'moment';
import Departments from '@/utils/constants/departmentsId';
import {
  getAdmissionLocations,
  getAdmissionCenters,
  getAdmissionMunicipalities,
  getAdmissionRegions,
  getAdmissionSchools,
  getAdmissionDistricts,
  getAdmissionStatusDelayReason,
  getReferralDetails,
} from '@/modules/shared/studentreferral.api';
import { validateIsActiveDayOfWeek as _validateIsActiveDayOfWeek } from '@/modules/shared/confRelatedServiceAcademicWeek.api';

const statusDelayReasonWithSubStatus = {
  PradresRechazanServicio: 6,
};

// Razón de rechazo de servicio: las razones de abajo son las que se muestran en otro dropdown
// cuando se selecciona "Padre rechazan el servicio por:" en el dropdown de razón de admisión tardía
const delayRejectedReasonIds = {
  ProblemasTransportacion: 7,
  MuyDistante: 8,
  NoInteresan: 9,
  EstudianteRecibeServicio: 10,
};

const LocationTypes = {
  Escuela: 135,
  OficinaProveedor: 136,
  CSEE: 137,
  Hogar: 482,
};
export default {
  components: {
    CustomDropDown,
    CustomDatePicker,
    CustomTimePicker,
    CustomTextArea,
    ActionButton,
  },
  mixins: [alert],
  props: {
    value: {
      type: Object,
      default: () => undefined,
    },
    dispose: {
      type: Function,
      default: function() {
        return () => {};
      },
    },
    save: {
      type: Function,
      default: function() {
        return () => {};
      },
    },
    update: {
      type: Function,
      default: function() {
        return () => {};
      },
    },
    admissionInfo: {
      type: Object,
      default: () => undefined,
    },
    hasPilotPermission: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      model: {
        locationType: null,
        region: null,
        school: null,
        municipality: null,
        location: null,
        district: null,
        assignmentSpecialist: null,
        center: null,
        delayReason: null,
        delayReasonExtra: null,
        delayReasonDescription: null,
      },
      collections: {
        regions: [],
        districts: [],
        schools: [],
        locations: [],
        municipalities: [],
        centers: [],
        delayReasons: [],
        delayReasonsExtra: [],
      },
      delay: {
        reasons: [],
        reasonsExtra: [],
      },
      newAdmissionDate: null,
      startDateDisabled: true,
      canUpdate: true,
      disabledForm: false,
      admission: {
        admissionTimeStart: null,
        admissionTimeEnd: null,
      },
      showDelayReason: false,
      showExtraDelayReason: false,
    };
  },
  computed: {
    canValidateActiveDayOfWeek() {
      // JSF: US101821 - validate if the selected day of week is active type when the admission date is not disabled
      const admissionDate = this.newAdmissionDate ?? null;
      const hasAdmissionDate = admissionDate != null;
      const needToValidate = hasAdmissionDate && !this.disabledAdmissionDate;

      return needToValidate && !this.admissionInfo.skipDayOfWeekValidation;
    },
    locationTypeSelected() {
      return this.model.locationType || {};
    },
    isSchool() {
      return this.locationTypeSelected.id === LocationTypes.Escuela;
    },
    isOficinaProveedor() {
      return this.locationTypeSelected.id === LocationTypes.OficinaProveedor;
    },
    isCsee() {
      return this.locationTypeSelected.id === LocationTypes.CSEE;
    },
    isHome() {
      return this.locationTypeSelected.id === LocationTypes.Hogar;
    },
    isEditMode() {
      return [
        AdmissionStatus.Admitido,
        AdmissionStatus.ServicioRelacionadoActivo,
      ].includes(this.value.statusId);
    },
    isAssignedStatus() {
      return this.value.statusId === AdmissionStatus.Asignado;
    },
    finishBtnText() {
      if (
        this.isAssignedStatus &&
        this.hasPilotPermission &&
        !this.hasAdmissionDate
      ) {
        return 'Añadir Nota de Admisión';
      }

      return this.isEditMode ? 'Actualizar' : 'Confirmar';
    },
    hasAdminPermission() {
      return this.userHasPermissions(
        'provider.referral.admission.specialist.edit'
      );
    },
    admissionSpecialistDisabled() {
      return !this.hasAdminPermission && this.isEditMode;
    },
    isAdmisionProvider() {
      return (
        this.$store.state['$_user'].user.profile.companyid ==
        this.value.companyId
      );
    },
    showServicePlaceSection() {
      let show = true;
      if (this.isAdmissionDateReadOnly && !this.model.locationType)
        show = false;

      return show;
    },
    // JSF: TEMP US91378 - this is a temporary hotfix for allowing the user to save the confirmation of an admission
    // if one of the dropdown for places are empty and it is in read only for bypassing the required validation
    temp_isServicePlaceSectionRequired() {
      let isRequired = true;

      if (this.isAdmissionDateReadOnly || this.disabledForm) {
        isRequired = false;
      }

      return isRequired ? 'required' : '';
    },
    isAdmissionDateReadOnly() {
      const admission = this.admissionInfo;
      const hasBilling = admission.hasBilling;
      const isReadOnly = !admission.isCurrentAcademicYear || hasBilling;

      return isReadOnly;
    },
    disabledAdmissionDate() {
      const admission = this.admissionInfo?.admission ?? {};
      const canEdit =
        admission.admissionStatusId === AdmissionStatus.Asignado &&
        this.isInitialReferralType &&
        !this.admissionInfo.hasBilling &&
        this.admissionInfo.isCurrentAcademicYear;

      if (canEdit) return false;

      if (!this.isEditMode) {
        if (admission.admissionDate) {
          return true;
        }
      } else {
        if (
          this.disabledForm ||
          //ECG:Se determina si existe algun referido ya admitido para el estudiante y la disciplina del admission seleccionado
          !this.admissionInfo.admissionDateVisibility
        ) {
          this.Toast(
            'Alerta',
            this.admissionInfo.admissionDateValidationMessage,
            'error',
            10000
          );
          return true;
        }
      }
      return false;
    },
    // JSF: If the admission is not for the current year and has override, then
    // use the override admissionId instead for filling the dropdowns.
    admissionIdForLocations() {
      let admissionId = this.value.admissionId;
      const overrideAdmissionId = this.admissionInfo
        .referralOverrideAdmissionId;

      if (!this.admissionInfo.isCurrentAcademicYear && overrideAdmissionId > 0)
        admissionId = overrideAdmissionId;

      return admissionId;
    },
    isInitialReferralType() {
      return this.value?.admissionCreationReasonId === ReferralTypes.Initial;
    },
    isContinuityReferralType() {
      return this.value?.admissionCreationReasonId === ReferralTypes.Continuity;
    },
    isEducationalDepartament() {
      return this.value.companyId === Departments.EducationDepartmentId;
    },
    hasAdmissionDate() {
      return (
        this.admissionInfo.admission.admissionDate != null &&
        this.admissionInfo.admission.admissionDate != undefined
      );
    },
  },
  watch: {
    'model.delayReason': {
      inmediate: true,
      handler: function(value) {
        this.showExtraDelayReason =
          value.id === statusDelayReasonWithSubStatus.PradresRechazanServicio;
      },
      deep: true,
    },
    'model.locationType': {
      inmediate: true,
      handler: function(value) {
        if (value !== null) {
          this.resetCollections();
          switch (value.id) {
            case LocationTypes.Escuela:
              this.getRegions();
              break;
            case LocationTypes.OficinaProveedor:
            case LocationTypes.CSEE:
            case LocationTypes.Hogar:
              this.getMunicipalities();
              break;
            default:
              break;
          }
        }
      },
      deep: true,
    },
    'model.region': {
      handler: function(value) {
        if (value === null) return;

        this.getDistricts();
      },
      deep: true,
    },
    'model.district': {
      handler: function(value) {
        if (value === null) return;

        this.getSchools();
      },
      deep: true,
    },
    'model.municipality': {
      handler: function(value) {
        if (value === null) return;
        if (this.locationTypeSelected.id === LocationTypes.CSEE)
          this.getCenters();
        else this.getLocations();
      },
      deep: true,
    },
  },
  mounted() {
    this.checkLinkedDate();
    this.getDelayReasons();

    this.newAdmissionDate = this.admissionInfo.admission.admissionDate
      ? new Date(this.admissionInfo.admission.admissionDate)
      : null;
    if (this.admissionInfo.admission.admissionTimeStart != null) {
      const [
        hour,
        minute,
      ] = this.admissionInfo.admission.admissionTimeStart
        .split(':')
        .map(Number);

      this.admission.admissionTimeStart = moment()
        .set({ hour, minute })
        .format('HH:mm');
    }

    if (this.admissionInfo.admission.admissionTimeEnd != null) {
      const [
        hour,
        minute,
      ] = this.admissionInfo.admission.admissionTimeEnd.split(':').map(Number);

      this.admission.admissionTimeEnd = moment()
        .set({ hour, minute })
        .format('HH:mm');
    }
    //set admission specilist
    if (this.admissionInfo.admission.assignmentSpecialistId)
      this.model.assignmentSpecialist =
        this.admissionInfo.assignmentSpecialist || {};

    //set service specialist
    if (this.admissionInfo.admission.serviceSpecialistId)
      this.model.serviceSpecialist = this.admissionInfo.serviceSpecialist || {};

    //set location type
    this.model.locationType = this.admissionInfo.locationTypes.find(
      (x) => x.id === this.admissionInfo.locationTypeId
    );

    //setStartDateVisibility
    this.startDateDisabled =
      !this.admissionInfo.startDateVisibility ||
      this.admissionInfo.isStartDateDisabled === true;

    //Cant update StartDate if is created from referral management
    if (this.admissionInfo.isFromReferralManagement && this.isEditMode) {
      this.startDateDisabled = true;
      this.Toast(
        'Alerta',
        this.admissionInfo.startDateValidationMessage,
        'error',
        10000
      );
    }

    //Disable update button if has billing
    if (this.admissionInfo.hasBilling && this.isEditMode) {
      this.canUpdate = false;
      this.disabledForm = true;
      this.Toast(
        'Alerta',
        this.admissionInfo.hasBillingValidationMessage,
        'error',
        10000
      );
    }
  },
  methods: {
    resetCollections() {
      this.collections = {
        regions: [],
        districts: [],
        schools: [],
        locations: [],
        municipalities: [],
        centers: [],
      };
    },
    async checkLinkedDate() {
      if (this.value.linkedDate == undefined) {
        await getReferralDetails(this.value.admissionId).then((res) => {
          this.value.linkedDate = res.data.linkedDate;
        });
        let linkedDate = moment(this.value.linkedDate, 'YYYY-MM-DD');
        let currentDate = moment().startOf('day');
        let diffDays = moment.duration(currentDate.diff(linkedDate)).asDays();
        if (diffDays > 15 ? true : false) {
          this.showDelayReason = true;
        }
      }
    },
    async getDelayReasons() {
      const { data } = await getAdmissionStatusDelayReason();

      // Filter out reasons that are not rejected
      const admissionDelayReasons = data.filter(
        ({ id }) => !Object.values(delayRejectedReasonIds).includes(id)
      );

      // las razones de admision tardia
      this.delay.reasons = admissionDelayReasons;

      // Filter reasons that are specifically for service rejection dropdown
      // that dropdown appears when the delay reason is "Padres rechazan el servicio por:"
      const delayReasons = data.filter(({ id }) =>
        Object.values(delayRejectedReasonIds).includes(id)
      );

      this.delay.reasonsExtra = delayReasons;

      // Set the first delay reason as the default if any exist
      if (delayReasons?.length > 0) {
        this.model.delayReason = delayReasons[0];
      }
    },
    async getCenters() {
      const { data } = await getAdmissionCenters(
        this.admissionIdForLocations,
        this.model.municipality.id,
        this.locationTypeSelected.id
      );
      this.collections.centers = data;

      if (this.admissionInfo.centerId)
        this.model.center = data.find(
          (x) => x.id === this.admissionInfo.centerId
        );
    },
    async getLocations() {
      const { data } = await getAdmissionLocations(
        this.admissionIdForLocations,
        this.model.municipality.id
      );
      this.collections.locations = data;

      if (this.admissionInfo.locationId)
        this.model.location = data.find(
          (x) => x.id === this.admissionInfo.locationId
        );
    },
    async getMunicipalities() {
      const { data } = await getAdmissionMunicipalities(
        this.admissionIdForLocations,
        this.locationTypeSelected.id
      );
      this.collections.municipalities = data;

      if (this.admissionInfo.municipalityId)
        this.model.municipality = data.find(
          (x) => x.id === this.admissionInfo.municipalityId
        );
    },
    async getSchools() {
      const { data } = await getAdmissionSchools(
        this.admissionIdForLocations,
        this.model.district.id,
        this.locationTypeSelected.id
      );

      this.collections.schools = data;

      if (this.admissionInfo.schoolId)
        this.model.school = this.collections.schools.find(
          (x) => x.id === this.admissionInfo.schoolId
        );
    },
    async getDistricts() {
      const { data } = await getAdmissionDistricts(
        this.admissionIdForLocations,
        this.model.region.id,
        this.locationTypeSelected.id
      );
      this.collections.districts = data;

      if (this.admissionInfo.districtId)
        this.model.district = data.find(
          (x) => x.id === this.admissionInfo.districtId
        );
    },
    async getRegions() {
      const { data } = await getAdmissionRegions(
        this.admissionIdForLocations,
        this.locationTypeSelected.id
      );
      this.collections.regions = data;

      if (this.admissionInfo.regionId)
        this.model.region = data.find(
          (x) => x.id === this.admissionInfo.regionId
        );
    },
    async finish(goToServiceCoordination) {
      const isValid = await this.$refs.formModalObserver.validate();
      if (!isValid) {
        this.ShowToast('Atención', 'Información Incompleta.', 'error');
        return;
      }
      if (
        this.newAdmissionDate &&
        this.admissionInfo.admission.effectiveDateFrom &&
        this.newAdmissionDate > this.admissionInfo.admission.effectiveDateFrom
      ) {
        this.ShowToast(
          'Atención',
          'La fecha de comienzo no debe ser menor a la de admisión.',
          'error'
        );
        return;
      }

      // JSF: US101821 - validate if the selected day of week is active for continuity referral type when the admission date is not disabled
      if (this.canValidateActiveDayOfWeek) {
        const payload = {
          entryDate: this.newAdmissionDate,
          flagType: ConfRelatedAcademicWeekFlagTypes.AdmissionFlag,
        };
        const { data: isActiveDayOfWeek } = await _validateIsActiveDayOfWeek(
          payload
        );
        if (!isActiveDayOfWeek) {
          this.ShowToast('Atención', 'Dia de visita no es lectivo', 'error');
          return;
        }
      }

      const admission = this.admissionInfo.admission;

      admission.serviceSpecialistId = this.model.serviceSpecialist?.id ?? null;
      admission.assignmentSpecialistId =
        this.model.assignmentSpecialist?.id ?? null;

      // JSF: TODO - se tiene que mandar el admission el lugar de servicio basado en el tipo de lugar
      // ejemplo: si tipo de lugar es Oficina del proveedor, entones hay que mandar locationTypeId
      // LocationId y MunicipalityId.
      let locationFiscalYearIdSelected = null;

      switch (this.locationTypeSelected.id) {
        case LocationTypes.Escuela:
          locationFiscalYearIdSelected = this.model.school?.id;
          break;
        case LocationTypes.OficinaProveedor:
          locationFiscalYearIdSelected = this.model.location?.id;
          break;
        case LocationTypes.CSEE:
          locationFiscalYearIdSelected = this.model.center?.id;
          break;
        case LocationTypes.Hogar:
          locationFiscalYearIdSelected = this.model.municipality?.id;
          break;
        default:
          break;
      }

      // JSF: TEMP US91378 - hotfix temporal para saltar la validacion de dropdowns requeridos para lugar de servicio
      // cuando está en modo lectura y pueda no traer datos en los dropdowns.
      if (!locationFiscalYearIdSelected) {
        locationFiscalYearIdSelected = this.admissionInfo?.admission
          ?.locationFiscalYearId;
      }
      const data = {
        admissionId: admission.admissionId,
        effectiveDateFrom: new Date(admission.effectiveDateFrom),
        effectiveDateTo: new Date(admission.effectiveDateTo),
        admissionDate: new Date(this.newAdmissionDate), // se guarda la fecha seleccionada
        locationFiscalYearId: locationFiscalYearIdSelected, //Se guarda la nueva localización para la admisión A.L
        assignmentSpecialistId: admission.assignmentSpecialistId,
        serviceSpecialistId: admission.serviceSpecialistId,
        admissionTimeStart: this.admission.admissionTimeStart,
        admissionTimeEnd: this.admission.admissionTimeEnd,
        // JSF: US101821 - validate if the selected day of week is active when the admission date is not disabled
        canValidateActiveDayOfWeek: this.canValidateActiveDayOfWeek,

        locationTypeId: this.model.locationType?.id,
        centerId: this.model.center ? this.model.center.id : null,
        schoolId: this.model.school ? this.model.school.id : null,
        regionId: this.model.region ? this.model.region.id : null,
        locationId: this.model.location ? this.model.location.id : null,
        municipalityId: this.model.municipality
          ? this.model.municipality.id
          : null,
        districtId: this.model.district ? this.model.district.id : null,

        hasBeenAdmittedForDiscipline: this.admissionInfo
          .hasBeenAdmittedForDiscipline,
        delayReasonId: this.model.delayReason
          ? this.model.delayReason.id
          : null,
        delayReasonComment: this.model.delayReasonDescription,
        goToServiceCoordination: goToServiceCoordination,
      };

      if (this.isEditMode) {
        this.update(data);
        return;
      }

      this.save(data);
    },
  },
};
</script>
